import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import AntInput from 'antd/lib/input';
import Table from 'antd/lib/table';

import { IconPlus } from '@tabler/icons-react';

import styles from './available-sites-card.module.css';

const { Search } = AntInput;

export default function AvailableSitesCard({ selectAllSites, sites, selectedSites, handleSearch, columns, loading }) {
    return (
        <Box className={styles.sitesSection}>
            <div className={styles.sectionHeader}>
              <div className={styles.headerLeft}>
                <Typography variant="h6">Available Sites</Typography>
              </div>
              <div className={styles.headerControls}>
                <Button
                  size="small"
                  marginRight="10px"
                  onClick={selectAllSites}
                  startIcon={<IconPlus size={16} />}
                  className={styles.selectButton}
                  disabled={sites.length === selectedSites.length}
                >
                  Select All
                </Button>
                <Search
                  placeholder="Search sites..."
                  onSearch={handleSearch}
                  className={styles.siteSearch}
                  allowClear
                />
              </div>
            </div>
            <Table
              columns={columns}
              dataSource={sites}
              loading={loading.sites}
              rowKey="site_id"
              pagination={{ pageSize: 10 }}
              className={styles.sitesTable}
              scroll={{ y: 'calc(100vh - 350px)' }}
            />
        </Box>
    )
}